import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = {
  href: "/",
  class: "site-logo"
}
const _hoisted_3 = { class: "top-bar-links" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "page-bg" }, null, -1)
const _hoisted_5 = { class: "page-header" }
const _hoisted_6 = { class: "page-title" }
const _hoisted_7 = { class: "content" }

import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { subscribe } from '@/core/events';
import auth from '@/core/Auth';
import TheLogoImg from '@/core/components/TheLogoImg.vue';
import TheMainNavigation from './TheMainNavigation.vue';
import TheUserZone from '@/core/components/TheUserZone.vue';
import FaIcon from '@/core/components/FaIcon.vue';
import AppButton from '@/core/components/form/AppButton.vue';

interface PageLayoutProps {
	pageTitle: string,
	baseTag?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PageLayout',
  props: {
    pageTitle: {},
    baseTag: { default: 'div' }
  },
  setup(__props: any) {

const store = useStore<AppStore>();
const props = __props;

const setTitle = () => {
	let pageTitle = store.getters.appName;
	if (props.pageTitle) {
		pageTitle = `${props.pageTitle} - ${store.getters.appName}`;
	}

	document.title = pageTitle;
};

onMounted(setTitle);
watch(() => props.pageTitle, setTitle);
watch(() => store.getters.appName, setTitle);

const page = ref<HTMLElement>();
const scrollSubscriber = subscribe('scrollPage', (target: number) => {
	if (page.value) {
		page.value.scrollTop = target;
	}
});
onBeforeUnmount(scrollSubscriber.unsubscribe);

// Mobile nav
const mobileNavOpen = ref(false);

onMounted(() => mobileNavOpen.value = false);

const logout = () => {
	auth.invalidate();
};

const toggleMobileNav = () => {
	mobileNavOpen.value = !mobileNavOpen.value;
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.baseTag), { class: "page" }, {
    default: _withCtx(() => [
      _createElementVNode("aside", {
        class: _normalizeClass(["page-sidebar", {open: mobileNavOpen.value}])
      }, [
        _createVNode(TheUserZone),
        _createVNode(TheMainNavigation)
      ], 2),
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("a", _hoisted_2, [
          _createVNode(TheLogoImg)
        ]),
        _createVNode(AppButton, {
          onClick: toggleMobileNav,
          class: "top-bar-toggle",
          icon: mobileNavOpen.value ? 'times' : 'bars',
          seamless: true
        }, null, 8, ["icon"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_RouterLink, {
            to: { name: 'user.profile' },
            class: "top-bar-link"
          }, {
            default: _withCtx(() => [
              _createVNode(FaIcon, { icon: "user-cog" }),
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Min profil")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(AppButton, {
            onClick: logout,
            class: "top-bar-link",
            icon: "sign-out",
            seamless: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Logga ut")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("main", {
        class: "page-main",
        ref_key: "page",
        ref: page
      }, [
        _hoisted_4,
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _createElementVNode("header", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.pageTitle), 1),
            _createElementVNode("div", null, [
              _renderSlot(_ctx.$slots, "header-actions")
            ])
          ])
        ]),
        _renderSlot(_ctx.$slots, "content", {}, () => [
          _createElementVNode("section", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ], 512)
    ]),
    _: 3
  }))
}
}

})